import shared from '../pages/shared.module.css';
import styles from './TargetingSummary.module.css';

interface TargetingRuleView {
	attribute: string;
	operator: string;
	value: string | number | string[];
}

interface TargetingView {
	match: 'all' | 'any';
	rules: TargetingRuleView[];
}

function formatRuleValue(value: string | number | string[]): string {
	if (Array.isArray(value)) return value.join(', ');
	return String(value);
}

export function TargetingSummary({
	targeting,
	emptyMessage,
}: {
	targeting: TargetingView | null | undefined;
	emptyMessage: string;
}) {
	if (!targeting) {
		return <p className={styles.empty}>{emptyMessage}</p>;
	}

	return (
		<>
			<p className={shared.targetingMatch}>
				Match <strong>{targeting.match === 'all' ? 'ALL' : 'ANY'}</strong> of:
			</p>
			<ul className={shared.ruleList}>
				{targeting.rules.map((rule, i) => (
					// biome-ignore lint/suspicious/noArrayIndexKey: read-only display
					<li key={i} className={shared.ruleItem}>
						<span className={shared.ruleAttr}>{rule.attribute}</span>
						<span className={shared.ruleOp}>{rule.operator}</span>
						<span className={shared.ruleVal}>{formatRuleValue(rule.value)}</span>
					</li>
				))}
			</ul>
		</>
	);
}
